import React from 'react';
import classNames from 'classnames';

export const CountBadge = ({ count = 1, color = 'red', className }) => {
  const title = count > 9 ? '9+' : count;
  const bgColor = `bg-${color}-500`;

  return (
    <span
      className={classNames(
        'inline-flex items-center justify-center rounded-full px-2 py-1 text-xs font-bold leading-none text-white',
        bgColor,
        className
      )}
      aria-label={`Count: ${title}`}
    >
      {title}
    </span>
  );
};
